import { z } from "zod"

import { subtitleStyleSchema } from "@postsunday/remotion-shared/lib/validations/element"

interface SubtitleConfig {
  readonly id: string
  readonly name: string
  style: Partial<z.infer<typeof subtitleStyleSchema>>
  wordsAtATime: number
  thumbnailUrl: string
  animationStyle: "scale" | undefined
}

const defaultSubtitleConfig = {
  id: "default" as const,
  name: "Default" as const,
  wordsAtATime: 4,
  style: {
    casing: "uppercase",
    fontFamily: "Inter",
    fontWeight: "900",
    color: "#ffffff",
  },
  thumbnailUrl: "/subtitles/default.png",
  animationStyle: undefined,
} as const satisfies SubtitleConfig

const playfulSubtitleConfig = {
  id: "playful" as const,
  name: "Playful" as const,
  wordsAtATime: defaultSubtitleConfig.wordsAtATime,
  style: {
    ...defaultSubtitleConfig.style,
  },
  thumbnailUrl: "/subtitles/playful.png",
  animationStyle: "scale",
} as const satisfies SubtitleConfig

const hormoziSubtitleConfig = {
  id: "hormozi" as const,
  name: "Hormozi" as const,
  wordsAtATime: 4,
  style: {
    casing: "uppercase",
    fontFamily: "Poppins",
    fontWeight: "800",
    color: "#ffffff",
    highlightBackgroundColor: "orange",
    highlightTextColor: "#ffffff",
    textShadow:
      "0 0 20px #000,0 0 21px #000,0 0 22px #000,0 0 23px #000,0 0 24px #000,0 0 25px #000,0 0 26px #000,0 0 27px #000,0 0 28px #000,0 0 29px #000",
    disableHighlight: true,
  },
  thumbnailUrl: "/subtitles/hormozi.png",
  animationStyle: undefined,
} as const satisfies SubtitleConfig

const boldSubtitleConfig = {
  id: "bold" as const,
  name: "Bold" as const,
  wordsAtATime: 4,
  style: {
    casing: "none",
    fontFamily: "Poppins",
    fontWeight: "300",
    color: "#ffffff",
    highlightFontStrokeWidth: "2px",
    disableHighlight: true,
  },
  thumbnailUrl: "/subtitles/bold.png",
  animationStyle: undefined,
} as const satisfies SubtitleConfig

export const subtitles = {
  [defaultSubtitleConfig.id]: defaultSubtitleConfig,
  [playfulSubtitleConfig.id]: playfulSubtitleConfig,
  [hormoziSubtitleConfig.id]: hormoziSubtitleConfig,
  [boldSubtitleConfig.id]: boldSubtitleConfig,
} as const satisfies Record<string, SubtitleConfig>
